import { useQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { residentMessageCategoriesSchema } from '../../../common/validations/residentMessageTimelineSchema'
import { get } from '../apiClient'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

const path = (contractUuid: string) =>
  API_ENDPOINTS.MESSAGE_CATEGORIES.replace(':contractUuid', contractUuid)

export const useAPIGetResidentMessageCategories = () => {
  const { currentContractId: contractUuid } = useCurrentContract()

  return useQuery({
    queryKey: ['resident-message-categories', contractUuid],
    queryFn: () => get(path(contractUuid), residentMessageCategoriesSchema),
  })
}
